import { readEnvVar } from '../../env.runtime.js';

const TRUTHY_VALUES = new Set(['1', 'true', 'yes', 'on']);

export function isPasskeysEnabled(): boolean {
  const raw = readEnvVar('VITE_PASSKEYS_ENABLED');
  if (raw === undefined || raw.trim() === '') return true;
  return TRUTHY_VALUES.has(raw.trim().toLowerCase());
}
